import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPromises,
  createPromise,
  updatePromises,
  deletePromise,
  getPromiseById,
} from "api/promises.api";

export const getPromisesAsync = createAsyncThunk(
  "promises/get-all",
  async () => {
    const data = await getPromises();
    return data;
  },
);

export const getNextPromisesAsync = createAsyncThunk(
  "promises/get-all-next",
  async (last) => {
    const data = await getPromises(last);
    return data;
  },
);

export const getPromiseByIdAsync = createAsyncThunk(
  "promise/get-by-id",
  async (id) => {
    const promise = await getPromiseById(id);
    const response = await fetch(promise.content);
    const text = await response.text();
    return { ...promise, content: text };
  },
);

export const createPromiseAsync = createAsyncThunk(
  "promises/create",
  async (promise) => {
    const promises = await createPromise(promise);
    return promises;
  },
);

export const updatePromiseAsync = createAsyncThunk(
  "promise/update",
  async ({ id, data }) => {
    await updatePromises(id, data);
    return { id, ...data };
  },
);

export const deletePromiseAsync = createAsyncThunk(
  "promise/delete",
  async (id) => {
    await deletePromise(id);
  },
);
